<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit">
          <div class="fl" style="justify-content: space-between; margin-left: 6px;">
            <span style="width: 63px; background-color: #589ff9" @click="uploadEvt">
              <img src="../../../assets/increase.png" style="width: 15px; height: 15px" alt="" />
            </span>
            <span style="width: 69px;" @click="clearEvt">ALL</span>
          </div>
          <el-tooltip class="item" content="公司">
            <el-input placeholder="公司" v-model="firm" clearable @change="getList">
            </el-input>
          </el-tooltip>
          <el-tooltip class="item" content="项目名">
            <el-input placeholder="项目名" v-model="project" clearable @change="getList">
            </el-input>
          </el-tooltip>
        </div>
        <div style="width:100%;">
          <div class="view_box">
            <div class=" fr12  fl">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5">
              </el-pagination>
              <div type="primary" @click="uploadEvt" class="shangchuan">上传素材</div>
              <div type="primary" @click="CloneEvt" class="shangchuan">刪除</div>

              <img v-if="changing == 1" style="
                                      width: 20px;
                                      height: 20px;
                                      line-height: 20px;
                                      position: relative;
                                      top: 5px;
                                    " src="../../../assets/1.png" />
              <img v-else style="
                                      width: 20px;
                                      height: 20px;
                                      cursor: pointer;
                                      position: relative;
                                      top: 5px;
                                    " @click="changingEvt(1)" src="../../../assets/2.png" />
              <img v-if="changing == 2" style="width: 20px; height: 20px; position: relative; top: 5px"
                src="../../../assets/4.png" />
              <img v-else style="
                                      width: 20px;
                                      height: 20px;
                                      cursor: pointer;
                                      position: relative;
                                      top: 5px;
                                    " @click="changingEvt(2)" src="../../../assets/3.png" />
              <img v-if="changing == 3" style="width: 20px; height: 20px; position: relative; top: 5px"
                src="../../../assets/5.png" />
              <img v-else style="
                                      width: 20px;
                                      height: 20px;
                                      cursor: pointer;
                                      position: relative;
                                      top: 5px;
                                    " @click="changingEvt(3)" src="../../../assets/6.png" />
              <div>
              </div>
            </div>
          </div>
          <div class="content">
            <el-scrollbar>
              <div class="img-box">
                <div class="flex-images" @scroll="imgScrollEvt" v-if="changing != 3">
                  <div class="item" v-for="(e, index) in imgArr" :key="index" :data-w="changing == 1 ? '503' : e.width"
                    style="display:flex;background-color: #d1d1d1;" :data-h="changing == 1 ? '360' : e.height"
                    @mousemove="mousemoveEvt(e)" @mouseout="mouseoutEvt" @click.stop="imgEvt(e,)"
                    @contextmenu.prevent="rightClickEvt(e)">
                    <div style="display: flex;flex-wrap: wrap;align-items: center;width: 100%;   ">
                      <div :class="changing === 1 ? 'img_two' : 'img_twoe'">
                        <img :src="e.thumb" alt="">
                      </div>
                      <div   class="max_one">
                        <span v-if="e.project !== ''" :style="{ color: '#000' }">{{ e.project }}</span>
                        <span v-else :style="{ color: '#fff' }">1</span>
                        <div>
                          <span v-if="e.firm !== ''" :style="{ color: '#000' }">{{ e.firm }}</span>
                          <span v-else :style="{ color: '#fff' }">1</span>
                          <span style="float: right;color: #000;margin-top: -3px;">{{ e.width }} * {{ e.height }}</span>
                        </div>
                      </div>
                      <div class="select" :style="{ display: e.select == true ? 'block' : 'none' }"
                        v-if="checkValue == false">
                        <i class="el-icon-check"></i>
                      </div>
                      <!-- checked为true  -->
                      <div class="select1" v-if="checkValue == true ? true : false">
                        <span>{{ e.dup_num }}</span>
                      </div>
                      <!-- checked为true  -->
                      <div class="select" :style="{ display: e.select == true ? 'block' : 'none' }">
                        <i class="el-icon-check"></i>
                      </div>
                      <div class="mask" v-show="maxsx" @click="closePopover"></div>
                      <el-popover ref="popoverRef" placement="right-start" width="300" height="340" trigger="manual"
                        v-model="e.visible">
                        <div class="operation_center">
                          <div>
                            <div style="display: flex;width: 300px;justify-content: space-between;">
                              <el-radio-group v-model="radio"
                                style="height: 140px;display: flex;justify-content: space-between;flex-direction: column;">
                                <el-radio :label="1">原始素材</el-radio>
                                <el-radio :label="2">上架中</el-radio>
                                <el-radio :label="3">下架中</el-radio>
                                <el-radio :label="4">回收站</el-radio>
                              </el-radio-group>
                              <el-radio-group v-model="radio_one" @input="handleInput"
                                style="height: 140px;display: flex;justify-content: space-between;flex-direction: column;">
                                <el-radio :label="1" :class="{ 'gray-text': kindValues.includes(1) }">Interior</el-radio>
                                <el-radio :label="2" :class="{ 'gray-text': kindValues.includes(2) }">Exterior</el-radio>
                                <el-radio :label="3" :class="{ 'gray-text': kindValues.includes(3) }">Animation</el-radio>
                                <el-radio :label="4" :class="{ 'gray-text': kindValues.includes(4) }">VR360</el-radio>
                              </el-radio-group>
                            </div>
                            <div style="width:280px;height: 60px;margin-top:50px;" class="popover">
                              <div style="display: flex;font-size: 12px;margin-left: 22px;">
                                <span>公司</span>
                                <el-input style="width:210px;margin-left: 11px;outline: none;"
                                  v-model="firm_one"></el-input>
                              </div>
                              <div style="display: flex;font-size: 12px;margin-top: 20px">
                                <span>项目名字</span>
                                <el-input style="width:210px;height: 20px;margin-left: 10px;outline: none;"
                                  v-model="project_two"></el-input>
                              </div>
                            </div>
                          </div>
                          <div class="btn_box">
                            <el-button size="mini" ref="coverCancel" @click="quxiao(e)">取消</el-button>
                            <el-button type="primary" size="mini" @click="seekEvt(e)">确定</el-button>
                          </div>
                        </div>
                        <span slot="reference"></span>
                      </el-popover>
                    </div>
                  </div>
                </div>

                <List v-if="changing == 3" :data="imgArr" @Min_BOX="Min_BOX" ref="sortTable" />

              </div>
            </el-scrollbar>
          </div>
        </div>

        <el-dialog title="" :visible.sync="searchLabelDialog" width="1300px" :top="dialogTop_one"
          custom-class="searchLabel" :show-close="false">
          <div style="width: 100%;border:1px solid;height: 800px;">
            <div class="image-container">
              <button class="prev-button" @click="prevImage"></button>
              <div v-for="(e, index) in infoArr" :key="index" v-show="index === currentIndex">
                <img :src="e.url" style="height:800px;width: 100%;">
                <div>
                  <span>{{ e.project_name }}</span>
                  <span>{{ e.staff }}</span>
                </div>
              </div>
              <button class="next-button" @click="nextImage"></button>
            </div>
          </div>
        </el-dialog>
      </div>
    </el-main>
    <!-- 文件上传开始 -->
    <el-dialog title="上传参考" :visible.sync="uploadVisible" width="90%" :close-on-press-escape="true" :top="dialogTop"
      :destroy-on-close="true">
      <Upload />
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="500px" :show-close="false">
      <div>此操作将该文件放入回收站, 是否继续?</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/js/flex-images.js";
import GlobalHeader from '../menu.vue';
import Upload from '../../../upload'
import List from '../../../components/list'
import { IndexApi, EditApi, } from "../../../api/work/index"
export default {
  components: {
    GlobalHeader,
    Upload,
    List
  },
  data() {

    return {
      activeIndex: "3",

      value1: "",
      value2: "",
      sortName: "排序方式",
      review: null,
      //收藏次数
      //排序数据
      sort: null,
      changing: 1,
      uploadVisible: false,
      imgArr: [],
      total: null,
      paginationInput: 95,
      currentPage1: 1,
      shiftFirst: false,  //键盘抬起


      //已选中图片数据
      selectArr: [],
      checkValue: false, //chenced的默认值

      form: {},
      formLabelWidth: '120px',

      ids: null,
      project_id: null,
      staff_id: null,


      project: null,
      project_one: null,

      staff: null,
      staff_one: [],
      labelArr: null,

      name: null,
      customer: null,
      charge: null,
      charge_id: null,
      sign: null,
      set_of: null,
      assistant: null,
      assistant_id: null,
      isValue3Empty_2: true,
      isValue3Empty_3: true,
      make: null,
      make_one: null,
      content_remark: null,

      searchLabelDialog: false,
      infoArr: [],
      currentIndex: 0,

      orField: null,
      orWhere: null,
      copyBrand: [],
      dialogTop: null, // 初始值为1vh
      dialogTop_one: null,

      visible: false,
      checkList: [],
      selected: '',
      radio: null,
      radio_one: null,
      type: 3,

      firm: null,
      dialogTableVisible: false,
      maxsx: false,
      dialogVisible: false,

      firm_one: null,
      project_two: null,

      kindValues: [],


    };
  },
  created() {

    this.changing = localStorage.getItem('num');
    if (this.changing === null) {
      this.changing = 1;
    }
    IndexApi({
      type: this.type,
    }).then(res => {
      this.imgArr = res.data.items
      this.total = res.total,
        this.currentPage1 = res.page - 0;
      this.totalRow = res.totalRow;
    })

    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener("keyup", this.handKeyEvt, true);
  },
  mounted() {
    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  updated() {
    this.$nextTick(() => {
      new flexImages({
        selector: ".flex-images",
        rowHeight: 280
      });
    });
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);

    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {



    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = '8vh'
        this.dialogTop_one = '1vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = '10vh'
        this.dialogTop_one = '10vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = '15vh'
        this.dialogTop_one = '15vh'

      } else if (window.innerWidth <= 3840) {
        this.dialogTop = '20vh'
        this.dialogTop_one = '20vh'

      }
    },
    //关闭弹窗前的
    clone_eEvt() {
      this.project = '';
      this.staff = '';
    },



    //刪除图片
    CloneEvt() {
      this.dialogVisible = true
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm() {
      EditApi({
        ids: this.getSourceId(),
        type: 4,
      }).then((res) => {
        if (res.code == 1000) {
          this.dialogVisible = false;
          this.getList()
        }
      })
    },


    //下拉查找中文字母查詢
    pinyingMatch(val) {
      var inputValue = val; // 保存输入的值
      if (val) {
        var result = [];
        this.copyBrand.forEach(e => {
          var matched = true;
          for (var i = 0; i < val.length; i++) {
            var m = pinyinMatch.match(e.name, val.slice(i, i + 1));
            if (!m) {
              matched = false;
              break;
            }
          }
          if (matched) {
            result.push(e);
          }
        });
        this.staff_one = result;
      } else {
        this.staff_one = this.copyBrand;
      }
      this.staff = inputValue; // 将输入的值赋值回输入框
    },
    //空格打开弹窗关闭事件
    clearValues() {
      // 清空相关值
      this.infoArr = [];
      this.currentIndex = 0;
    },
    //切换上一页
    prevImage() {
      if (this.currentIndex > 0) {
        3
        this.currentIndex--;
      }
    },
    //切换下一页
    nextImage() {
      if (this.currentIndex < this.infoArr.length - 1) {
        this.currentIndex++;
      }
    },
    //键盘抬起事件
    handKeyEvt(e) {
      e = e || window.event;
      if (e.keyCode == 16) {
        this.shift = false;
        this.shiftFirst = false;
      }
    },
    //空格事件
    handKeyCode(e) {
      e = e || window.event;
      if (this.imgArr.filter((res) => res.select == true).length !== 0) {
        //空格空格事件
        if (e.keyCode == 32) {
          e.preventDefault();
        }
        // 键盘左键事件
        if (e.keyCode == 37) {
          if (this.spaceDialogNum == 1) {
            return;
          }
          e.preventDefault();
          this.spaceDialogNum -= 2;
          this.spaceDialogEvt();
        }
        //键盘右键事件
        if (e.keyCode == 39) {
          if (this.spaceDialogNum == this.selectArr.length) {
            return;
          }
          e.preventDefault();
          this.spaceDialogEvt();
        }
      }
      //shift 事件
      if (e.keyCode == 16) {
        this.shift = true;
        this.shiftFirst = true;
      }
      //键盘0清除选择
      if (e.keyCode == 48 || e.keyCode == 96 || e.keyCode == 67) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          return;
        }
        this.imgArr = this.imgArr.map(res => {
          res.select = false;
          return res;
        });
        this.selectArr = this.imgArr.filter(res => res.select == true);
      }
      //键盘A事件（全选）
      // if (e.keyCode == 65) {
      //   this.imgArr = this.imgArr.map(res => {
      //     res.select = true;
      //     return res;
      //   });
      //   this.selectArr = this.imgArr.filter(res => res.select == true);
      // }

      //按下del删除弹窗事件
      if (e.keyCode == 110) {
        this.CloneEvt()
      }
       //按下i进行切换
      if (e.keyCode == 73) {
        if (this.changing >= 3) {
          this.changing = 1;
        } else {
          this.changing++;
        }
        this.changingEvt(this.changing);
      }
    },
    //排序

    //切换排序方式
    changingEvt(e) {
      this.changing = e
      localStorage.setItem('num', e);
    },
    //将排序参数传递给子组件
    Min_BOX(props) {
      this.orField = props.orWhere;
      (this.orWhere = props.order), this.getList();
    },
    mousemoveEvt() {
    },
    mouseoutEvt() {
    },
    //上传
    uploadEvt() {
      this.uploadVisible = true;
    },

    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 100)
    },
    // 获取已选中图片的source_id
    getSourceId() {
      var source_ids = this.selectArr.map(res => res.id);
      return source_ids;
    },
    //图片点击事件
    imgEvt(e) {
      this.imgArr.forEach(img => {
        this.maxsx = false
        img.visible = false;
      });
      if (this.selectArr.length >= 1 && this.shift === true) {
        let start = -1,
          end = -1;
        for (var i = 0; this.imgArr.length > i; i++) {
          if (this.imgArr[i].id === e.id) {
            start = i;
          }
          if (this.imgArr[i].id !== e.id && this.imgArr[i].select === true) {
            end = i;
          }
        }
        if (start !== -1 && end !== -1) {
          if (start > end) {
            let temp = "";
            temp = end;
            end = start;
            start = temp;
          } else {
            start++;
          }
          for (var i = 0; this.imgArr.length > i; i++) {
            if (i >= start && i < end) {
              this.imgArr[i].select = true;
            }
          }
        }
      }
      this.imgArr = this.imgArr.map(res => {
        if (res.id == e.id) {
          res.select = !res.select;
        }
        return res;
      });
      this.selectArr = this.imgArr.filter(res => res.select == true);
    },
    closePopover(event) {
      this.selectArr.filter(res => {
        res.visible = false
        this.maxsx = false;
        this.kindValues = []
      })
      event.stopPropagation()
    },
    quxiao(e) {
      this.maxsx = false;
      e.visible = false
      this.firm_one = ''
      this.project_two = '',
        this.kindValues = []
    },
    //图片鼠标右键事件
    rightClickEvt(e) {
      if (this.selectArr.length !== 0) {
        // 判断当前点击的图片是否在选中的图片数组中
        const clickedImage = this.imgArr.find(img => img.id === e.id);

        if (this.selectArr.length > 1) { // 只有在多选的情况下才进行循环判断
          let newKind = null; // 初始化新的值为 null
          for (let i = 0; i < this.selectArr.length; i++) {
            const kind = this.selectArr[i].kind;
            this.kindValues.push(kind); // 将当前图片的 kind 值添加到数组
            if (newKind === null) { // 如果新的值还没有被赋值，则将其赋值为当前的 kind
              newKind = kind;
            } else if (newKind !== kind) { // 如果新的值已经被赋值，并且当前的 kind 和新的值不一致，则将 this.check__evt 赋值为 true
              this.radio_one = '';
            }
          }
          this.radio_one = ''; // 多选的情况下将 this.radio_one 赋值为空
        } else {
          this.radio_one = e.kind; // 只有一张图片的情况下将 this.radio_one 赋值为 e.kind
        }

        if (this.kindValues.every(value => value === this.kindValues[0])) {
          this.radio_one = e.kind;
        }
        this.radio = e.type;
        this.maxsx = true;
        this.dialogTableVisible = true;
        clickedImage.visible = true;
      }
    },
    //点击this.radio_one 清除掉this.kindValues 的颜色
    handleInput(val) {
      this.radio_one = val,
        this.kindValues = []
    },
    seekEvt(e) {
      EditApi({
        ids: this.getSourceId(),
        type: this.radio,
        kind: this.radio_one,
        firm: this.firm_one,
        project: this.project_two
      }).then((res) => {
        if (res.code == 1000) {
          e.visible = false
          this.maxsx = false;
          this.firm_one = ''
          this.project_two = ''
          this.getList()
        } else {
          alert(res.msg)
        }
      })
    },




    projectChange(value) {
      this.project = value;
    },
    staffChange(value) {
      this.staff = value;
    },


    imgScrollEvt(e) { },
    getList() {
      IndexApi({
        type: this.type,
        project: this.project,
        firm: this.firm,
        orField: this.orField,
        orWhere: this.orWhere,
      }).then(res => {
        this.imgArr = res.data.items
        this.total = res.total,
          this.currentPage1 = res.page - 0;
        this.totalRow = res.totalRow;
      })
    },
    clearEvt() {
      this.firm = '';
      this.project = '';
      this.selectArr = [];
      IndexApi({
        type: this.type,
      }).then(res => {
        this.imgArr = res.data.items
        this.total = res.total,
          this.currentPage1 = res.page - 0;
        this.totalRow = res.totalRow;
        this.$nextTick(res => {
          this.$refs.sortTable.resetSort();
        })
      })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../../assets/js/flex-images.css");
@import url("../../../style/Work_management.less");

.el-main {
  left: 173px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

.edit {
  // width: 1000px;

  display: flex;

  div {
    width: 137px;
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
    margin-left: 5px;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
    border: 1px solid #888a8f;
  }

  /deep/.el-input__icon {
    line-height: 0px;
  }
}

.view_box {
  display: flex;
  justify-content: end;

  .shangchuan {
    font-size: 12px;
    border: 1px solid #de5e5e5;
    border-radius: 3px;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
  }

  .el-dropdown {
    margin-top: 5px;
    margin-right: 10px;
    margin-left: 10px;
  }

  span {
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    font-size: 14px;
    padding: 4px 10px;
  }
}

.content {}


.Mapping_quantity {
  width: 100%;
  margin-top: 10px;
  background: #fff;

}

.image-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  // grid-auto-rows: 190px;
  grid-gap: 20px;
  height: 100%;
  min-height: 1000px;
}

// .img_one {
//   display: flex;
//   flex-wrap: wrap;
//   align-items: center;
//   width: 350px;
//   margin: 0 5px 0px 5px;
// }

.img_two {
  width: 100%;
  // width: 350px;
  // height: 100%;
  height: 246px;
  margin: auto;
  display: flex;
  background-color: #e5e5e5;
}

.img_twoe {
  width: 100%;
  height: 88%;
  margin: auto;
  display: flex;
  background-color: #e5e5e5;
}

.flex-images {

  // margin-bottom: 17px;
  // margin:0  10px  40px  10px;
  display:flex,
  .item {
    grid-template-columns: repeat(3, 1fr);
    /* 定义3列，每列宽度相等 */
    grid-gap: 20px;
    /* 定义网格间距 */
  }

  img {
    // object-fit: cover;
  }

  div {
    font-size: 12px;
    text-align: left;
  }
}


/deep/ .flex-images {
  width: 100%;
  overflow-y: scroll !important;
  height: 89.5vh;
  display: flex;
  flex-wrap: wrap;
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr 1fr 1fr  1fr;
  // grid-template-rows: 1fr 1fr;
}

.img-box {
  background: #fff;
}

.img-box .item {
  position: relative;
  display: flex !important;
  justify-content: center;
  border: none;
  transition: all 0.5s ease;
}

.img-box .item img {
  width: 100%;
  object-fit: cover;
  transition: all 0.5s ease;
}

.img-box .item img:hover {
  transform: scale(1.05);
}


.item_one {
  position: relative;
  // display: flex !important;
  // justify-content: center;
  border: none;
}




.select {
  position: absolute;
  right: -25px;
  top: -25px;
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: transparent #409eff transparent transparent;
  transform: rotate(135deg);
  color: #fff;
}

.select1 {
  position: absolute;
  left: 10px;
  top: 9px;
  width: 36px;
  height: 24px;
  color: #fff;
  background: #dd127b;
  border-radius: 6px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
}

.el-icon-check {
  position: absolute;
  font-size: 18px;
  top: -9px;
  left: 5px;
  transform: rotate(223deg);
}

.image-container {
  position: relative;
}

.prev-button {
  position: absolute;
  left: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.prev-button:hover {
  cursor: url("../../../assets/Ins.png"), auto;

}

.next-button {
  position: absolute;
  right: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.next-button:hover {
  cursor: url("../../../assets/Ins.png"), auto;
}

/deep/.el-select-dropdown__item span {
  width: 150px !important;
}

.operation_center {
  display: flex;
  position: relative;
  height: 300px;
  margin-top: 10px;
}

.center_box span {
  padding-left: 33px;
  font-size: 13px;
}

.center_box .el-checkbox {
  margin-top: 15px;
}

.operation_center .btn_box {
  position: absolute;
  bottom: 0px;
  right: 10px;
}

/deep/.el-radio__inner {
  border-radius: 0 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner::after {
  content: "✔";
  position: absolute;
  top: 0%;
  left: 5%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #fff;
}

/deep/.el-radio__inner::after {
  width: 0px;
  height: 0px;
  background-color: none;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.05);
  z-index: 9999;
}

.mask /deep/.el-popper {
  height: 360px;
}

.popover /deep/.el-input__inner {
  height: 20px;
}

.popover /deep/.el-input__inner:focus {
  border-color: #d1d1d1;
}

.gray-text {
  color: #d1d1d1;
}

.max_one{
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;

}
</style>



// WEBPACK FOOTER //
// src/backHome/components/retrieve/index.vue